/**
 * Component: Header navigation
 *
 * Dependencies:
 * - OwlCarousel 2.x.x
 */

var prongHorn = prongHorn || {};

prongHorn.fixedElement = prongHorn.fixedElement || function() {
    var $element = $('.js-fixed-element');
    var $page = $('.content--productpage');
    var pxFromTop = 0;
    var spacetoScroll = $element.length ? spaceToScroll() : 0;

    this.init = function() {
        var pxScrolled = $(window).scrollTop();
        var delta = pxScrolled - pxFromTop;


        if(delta > 0 && delta < spacetoScroll) {
            $element.css({"transform": "translate3d(0px, " + delta + "px, 0px)"});         
        } else if(delta > spacetoScroll) {
            $element.css({"transform": "translate3d(0px, " + spacetoScroll + "px, 0px)"})
        }
        else {
            $element.css({"transform": "translate3d(0px, 0px, 0px)"});
        }


    };

    this.reCalc = function() {

        if($element.length) {
            pxFromTop = $element.offset().top;
        }

    }

    // Calc if the div is hitting the footer
    function spaceToScroll(){
        var elBottomToTop = $element.offset().top + $element.outerHeight(true);
        var pageBottomToTop = $page.offset().top + $page.outerHeight(true);
        var pxLeft = pageBottomToTop - elBottomToTop;

        return pxLeft;
    }

    // Public functions
    return {
        init: init,
        reCalc: reCalc
    };

}();